/* Install as assets/veyro-buy-to-cart.js. No direct checkout or automatic retries. */
(() => {
  if (window.veyroBuyToCartInstalled) return;
  window.veyroBuyToCartInstalled = true;
  const busyForms = new WeakSet();
  document.addEventListener('click', async event => {
    const button = event.target instanceof Element ? event.target.closest('[data-veyro-buy-to-cart]') : null;
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = button.closest('form');
    if (!form || busyForms.has(form)) return;
    const wrapper = button.closest('.veyro-buy-to-cart');
    const errorNode = wrapper.querySelector('[data-veyro-buy-error]');
    const cartLink = wrapper.querySelector('[data-veyro-buy-cart-link]');
    const label = button.querySelector('[data-veyro-buy-label]');
    const originalLabel = label.textContent;
    errorNode.hidden = true; cartLink.hidden = true;
    const showError = message => {errorNode.textContent = message; errorNode.hidden = false;};
    if (!form.checkValidity()) {form.reportValidity();return;}
    const nativeAdd = form.querySelector('button[name="add"]');
    if (nativeAdd?.disabled) {showError('Оберіть доступний варіант товару.');return;}
    // Includes the current variant ID, quantity, selling plan and line-item properties.
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    if (!/^\d+$/.test(id)) {showError('Спочатку оберіть варіант товару.');return;}
    if (!data.has('quantity')) {
      const quantityInput = form.closest('product-form-component')?.querySelector('input[name="quantity"]');
      const defaultQuantity = form.closest('product-form-component')?.dataset.quantityDefault || '1';
      data.set('quantity',quantityInput?.value || defaultQuantity);
    }
    const quantity = Number(data.get('quantity'));
    if (!Number.isInteger(quantity) || quantity < 1) {showError('Вкажіть коректну кількість.');return;}
    data.delete('checkout'); data.delete('return_to'); data.delete('form_type'); data.delete('utf8');
    const controls = Array.from(form.querySelectorAll('button[type="submit"],[data-veyro-buy-to-cart]')).map(element=>({element,disabled:element.disabled}));
    busyForms.add(form);
    controls.forEach(({element})=>{element.disabled=true;});
    label.textContent='Додаємо…';
    const root = window.Shopify?.routes?.root || '/';
    let rejectionMessage = '';
    const controller = new AbortController();
    const requestTimer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root+'cart/add.js',{
        method:'POST',headers:{Accept:'application/json'},body:data,
        signal:controller.signal
      });
      const result = await response.json();
      if (!response.ok || (result && Number(result.status) >= 400)) {
        rejectionMessage = typeof result?.description === 'string' && result.description.trim() && result.description.length <= 1000
          ? result.description : 'Сервіс кошика повідомив про помилку. Перевірте кошик перед повторною спробою.';
        throw new Error('Cart response rejected.');
      }
      // A successful HTTP status alone is not proof that THIS variant was added.
      // The returned quantity is the resulting line quantity, not an add delta.
      const items = Array.isArray(result?.items) ? result.items : [result];
      const confirmed = items.some(item => item && String(item.id) === id && Number.isInteger(item.quantity) && item.quantity >= quantity);
      if (!confirmed) throw new Error('Unconfirmed cart contents.');
      label.textContent='Відкриваємо кошик…';
      window.location.assign(root+'cart');
    } catch(error) {
      showError(rejectionMessage || 'Не вдалося підтвердити додавання товару. Перевірте кошик перед повторною спробою.');
      cartLink.hidden=false;
      label.textContent=originalLabel;
      controls.forEach(({element,disabled})=>{element.disabled=disabled;});
    } finally {clearTimeout(requestTimer);busyForms.delete(form);}
  },true);
})();
